export const BUILD_VERSION = '1792433933';
